import React, { useState } from "react";

import Box from "./base/box";
import Flex from "./base/flex";

import Header from "./header";
import Footer from "./footer";
import ISISection from "./isi-section";
import Section from "./section";

import { useContentContext } from "../context/content-context";
import { ISIContext } from "../context/isi-context";
import useIsiSection from "../hooks/use-isi-section";

import LoadingSpinner from "./base/loading-spinner";

const PageWrapper = ({ children, references, variant, isModalOpen, CTA }) => {
  const { isLoading } = useContentContext();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const { isiAnchorRef, isInView, ISIScrollButton } = useIsiSection();

  return (
    <ISIContext.Provider
      value={{
        isiAnchorRef,
        isInView,
        ISIScrollButton,
      }}
    >
      <Box
        overflowY={isMobileNavOpen || isModalOpen ? "hidden" : "auto"}
        overflowX="hidden"
        height={isMobileNavOpen || isModalOpen ? "100dvh" : "unset"}
        position="relative"
      >
        <Header
          isMobileNavOpen={isMobileNavOpen}
          setIsMobileNavOpen={setIsMobileNavOpen}
          variant={variant}
          ISIScrollButton={ISIScrollButton}
        />
        <main role="main">
          {isLoading ? (
            <Flex
              justifyContent="center"
              alignItems="center"
              height="calc(100dvh - 300px)"
            >
              <LoadingSpinner variant="gray" />
            </Flex>
          ) : (
            children
          )}
          <ISISection
            ref={isiAnchorRef}
            isInView={isInView}
            ISIScrollButton={ISIScrollButton}
          />
          {references && (
            <Section p={["0 28px 20px", "0 32px 32px", "0 32px 32px"]}>
              <Box dangerouslySetInnerHTML={{ __html: references }} />
            </Section>
          )}

          {CTA && <CTA />}
        </main>

        <Footer variant={variant} />
      </Box>
    </ISIContext.Provider>
  );
};

export default PageWrapper;
